UsersIndex

<template>
	<div id="wrapper">
		<SidebarView :journal="true" :journal-index="true" :journal-visible="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container-fluid">
					<!-- begin row  -->
					<div class="row">
						<div class="col-lg-12">
							<div class="card card-shape home-box">
								<div class="card-header d-flex flex-row align-items-center justify-content-between">
									<h6 class="m-0 fw-bold text-green">
										All Journals
									</h6>
									<div class="d-flex">
										<b-button size="sm" class="btn-size akkurate-green-btn" href="/journal/create"
											variant="primary">
											<span class="akkurate-small">
												<i class="fas fa-plus"></i> Add
												Journal</span>
										</b-button>
										<div>
											<b-link @click="exportToExcel" class="fw-semibold ms-2 akkurate-green">
												<font-awesome-icon :icon="['fas', 'file-excel']" /></b-link>
										</div>
									</div>
								</div>
								<div class="card-body py-3 default_bg" style="
										border-bottom: 1px solid
											rgb(1, 134, 115);
									">
									<div class="home-box border border-success p-3 bg-white text-center">
										<errors v-if="errors">
											{{ errors }}
										</errors>
										<form @submit.prevent="filterTable">
											<journal-voucher-filter :form="form" :users_options="users_options"
												:branch_options="branch_options
													"></journal-voucher-filter>
										</form>
									</div>
								</div>
								<div class="card-body pt-3">
									<div class="table_text_size">
										<b-table striped bordered responsive id="voucher-table" :busy.sync="isBusy"
											:items="rows" :fields="fields" :tbody-tr-class="rowClass" show-empty>
											<template #table-busy>
												<div class="text-center text-danger my-2">
													<b-spinner class="align-middle"></b-spinner>
													<strong>Loading...</strong>
												</div>
											</template>
											<template #cell(created_by)="data">
												<div>
													{{
														data.item.created_by?.first_name
													}}
													{{
														data.item.created_by?.surname
													}}
												</div>
											</template>
											<template #cell(status)="data">
												<span :class="statusBadge(
													data.item.status
												)
													">{{
														data.item.status
													}}</span>
											</template>
											<template #cell(amount_requested)="data">
												<span>{{
													displayNumber(
														data.item
															.amount_requested
													)
												}}</span>
											</template>
											<template #empty="scope">
												<h4 class="text-center small mt-3">
													{{ scope.emptyText }}
												</h4>
											</template>
											<!-- <template #cell(references)="data">
												<span>JOU{{ data.item.id }}</span>
											</template> -->
											<template #cell(references)="data">

												<b-link v-if="data.item.status == 'DISBURSED'"
													v-b-tooltip.hover="{ variant: 'info' }"
													title="Click to view ledger entries"
													class="text-decoration-none akkurate-green"
													:href="`/chart-of-accounts/transactions?reference=JOU${data.item.id}`">
													JOU{{ data.item.id }}
												</b-link>
												<div v-else>
													JOU{{ data.item.id }}
												</div>
											</template>
											<template #cell(actions)="data">
												<span class="d-flex">
													<journal-view :data="data.item" />
													<a v-if="
														data.item.status !=
														'REJECTED' &&
														data.item.status !=
														'APPROVED' &&
														data.item.status !=
														'DISBURSED' &&
														data.item.status !=
														'REVERSED'
													" title="Approve" class="btn btn-sm akkurate-green-btn custom-pointer text-white"
														:href="`/journal/approve/${data.item.id}`">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'check',
														]" /></span>
													</a>
													<a v-if="status_permission" title="Edit" class="btn btn-sm akkurate-blue text-white border-0"
														:href="`/journal/${data.item.id}/edit`">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'edit',
														]" /></span>
													</a>
													<reject :data="data.item" @rejected="
														rejected
													"></reject>

													<a v-if="
														data.item.status ==
														'APPROVED'
													" :disabled="isDisbursing" title="Disburse" @click="
														disburseJournal(
															data.item.id
														)
														" class="btn btn-sm akkurate-gray-btn text-white custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'exchange-alt',
														]" /></span>
													</a>
													<a v-if="
														data.item.status == 'DISBURSED'" :disabled="isReversing" title="Reverse"
														@click="reverseJournal(data.item.id)"
														class="btn btn-sm akkurate-gray-btn text-white custom-pointer">
														<span class="akkurate-small"><font-awesome-icon :icon="[
															'fas',
															'arrow-rotate-left',
														]" /></span>
													</a>
												</span>
											</template>
										</b-table>
										<div class="d-flex justify-content-between">
											<b-pagination class="mt-1" @change="navigatePage" v-model="currentPage"
												:total-rows="totalRecords" :per-page="perPage"
												aria-controls="voucher-table"></b-pagination>
											<!-- <b-form-select @change="selectPerPage" v-model="per_page_selected" :options="per_page_options"
                        size="sm" class="mt-3"></b-form-select> -->
											<div class="col text-end mt-1 akkurate-dark">
												<div>
													{{ currentPage }} -
													{{ perPage }} of
													{{ totalRecords }}
												</div>
												<b-form-group label="Per Page" label-size="sm" class="mb-0">
													<b-form-select @change="selectPerPage" id="per-page-select"
														v-model="perPage" :options="per_page_options
															" size="sm"></b-form-select>
												</b-form-group>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!-- end row  -->
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>

<script>
// import BeatLoaderComponent from "@/views/components/Loader/BeatLoaderComponent.vue";

import ApiService from "@/core/services/api.service";

import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import Multiselect from "vue-multiselect";
import Reject from "../forms/modal/Reject.vue";
import JournalView from "../view/JournalView.vue";
import ExcelJS from "exceljs";
import JournalVoucherFilter from "../JournalVoucherFilter.vue";
import { hasPermission } from "@/helper";
import ChatBot from "@/views/components/AI/ChatBot.vue";

export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		Multiselect,
		Reject,
		JournalView,
		JournalVoucherFilter,
		ChatBot,
	},
	mounted() {
		let token = localStorage.getItem("token");
		if (!token) {
			this.$router.push({ path: "/login" });
		}
		this.loadItems();
		this.getVoucherDropdown();
		this.getInsistution();
		this.checkPemission();
	},

	data() {
		return {
			totalRecords: 0,
			searchFilter: "",
			isLoading: false,
			form: {
				status: "",
				branch: [],
				start_date: "",
				end_date: "",
				users: [],
			},
			more_details: false,
			isDisbursing: false,
			branch_arr: [],
			status_arr: [],
			users_arr: [],
			isReversing: false,
			users_options: [],
			branch_options: [],

			currentPage: 1,
			perPage: 10,
			per_page_options: ["10", "20", "50", "100", "500", "1000", '5000', '10000'],
			per_page_selected: "10",
			isBusy: false,
			errors: "",
			fields: [
				{
					label: "Record.Date",
					key: "recorded_date",
				},
				{
					label: "Code",
					key: "code",
				},
				{
					label: "References",
					key: "references",
				},
				{
					label: "Branch",
					key: "branch.name",
				},
				{
					label: "Amount.Request",
					key: "amount_requested",
				},
				{
					label: "Narration",
					key: "narration",
				},
				{
					label: "Status",
					key: "status",
				},
				{
					label: "Created by",
					key: "created_by",
				},
				{
					label: "Actions",
					key: "actions",

					html: true,
					//   formatFn: this.renderActions,
				},
			],
			rows: [],
		};
	},

	methods: {
		statusBadge(item) {
			if (item === "APPROVED") {
				return "badge akkurate-blue";
			} else if (item === "REJECTED") {
				return "badge akkurate-gray-bg";
			} else if (item === "DISBURSED") {
				return "badge akkurate-green-bg";
			} else if (item === "PENDING") {
				return "badge akkurate-warning-bg";
			} else if (item === "REVERSED") {
				return "badge akkurate-danger-bg";
			} else {
				return "badge akkurate-warning-bg";
			}
		},
		rowClass() {
			return "custom-row-height";
		},
		filterTable() {
			this.loadItems();
		},

		navigatePage(index) {
			this.isBusy = true;
			this.currentPage = index;
			this.loadItems();
		},
		selectPerPage(index) {
			this.perPage = index;
			this.loadItems();
		},

		async getVoucherDropdown() {
			this.$Progress.start();
			await ApiService.get("/journals/dropdown")
				.then((response) => {
					this.$Progress.finish();
					this.branch_options = response.data.branches;
					this.users_options = response.data.users;
				})
				.catch((error) => {
					this.$Progress.fail();
					// console.log(error);
				});
		},

		// load items is what brings back the rows from server
		async loadItems(searchFilter = null) {
			this.isBusy = true;
			this.isLoading = true;
			let users = [];
			let branches = [];
			//Reduce Users Array Object For Filters
			users = this.form.users?.reduce((accumulator, currentValue) => {
				accumulator.push(currentValue.id);
				return accumulator;
			}, []);
			//Reduce Branch Array Object For Filters
			branches = this.form.branch?.reduce(
				(accumulator, currentValue) => {
					accumulator.push(currentValue.id);
					return accumulator;
				},
				[]
			);
			await ApiService.post("/journals/paginate", {
				page: this.currentPage,
				per_page: this.perPage,
				filter: this.form.search,
				branch_ids: branches, //Eg. 1, 2, etc
				statuses: this.form.status,
				start_date: this.form.start_date,
				end_date: this.form.end_date,
				users_ids: users,
			})
				.then((response) => {
					// console.log(response.data.data);
					this.isBusy = false; // Set isBusy to false when the data is loaded
					this.$Progress.finish(); // Finish the progress bar

					this.totalRecords = response.data.meta.total;
					this.rows = response.data.data; // Return data to populate the table
				})
				.catch(() => {
					// console.log(error);
					this.isLoading = false;
				})
				.finally(() => {
					// this.isLoading = false
					this.isLoading = false;
				});
		},
		rejected() {
			this.loadItems();
		},

		onBranchChange() {
			this.branch_arr = [];
			if (this.form.branch.length > 0) {
				this.form.branch.map((index) => {
					this.branch_arr.push(index.id);
				});
			}
		},

		onUserChange() {
			this.users_arr = [];
			if (this.form.users.length > 0) {
				this.form.users.map((index) => {
					this.users_arr.push(index.id);
				});
			}
		},

		onStatusChange() {
			this.status_arr = [];
			if (this.form.status.length > 0) {
				this.form.status.map((index) => {
					this.status_arr.push(index);
				});
			}
			// console.log(this.status_arr);
		},
		async disburseJournal(index) {
			this.isDisbursing = true;
			// console.log(this.form);
			swal.fire({
				// title: response.data.transaction.trans_status,
				title: "Disburse Amount",
				// text: 'CODE : ' + response.data.transaction.code,
				text: "Are you sure?",
				confirmButtonColor: "#018673",
				icon: "question",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "Yes", // Customize the text for the "OK" button
				cancelButtonText: "No", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.errors = "";
					this.isLoading = true;
					this.isDisbursing = false;
					this.$Progress.start();
					await ApiService.post(`/journals/disburse/${index}`)
						.then((response) => {
							this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: response.data.message,
							});
							this.loadItems();
							// this.$bvModal.hide(String(this.loan_no + this.statement));
						})
						.catch((error) => {
							console.log(error.response.data.message);
							this.isDisbursing = false;
							this.isLoading = false;
							this.$Progress.fail();
							this.errors = error.response.data.message;
							// if (error.response.data.errors) {
							//     this.form.errors = error.response.data.errors;
							// }
						});
				} else if (result.isDismissed) {
					this.isDisbursing = false;
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
				}
			});
		},
		reverseJournal(index) {
			swal.fire({
				// title: response.data.transaction.trans_status,
				title: "Reverse Journal",
				// text: 'CODE : ' + response.data.transaction.code,
				text: "Are you sure?",
				confirmButtonColor: "#018673",
				icon: "question",
				allowOutsideClick: false,
				allowEscapeKey: false,
				showCancelButton: true, // Show the "Cancel" button
				confirmButtonText: "No", // Customize the text for the "OK" button
				cancelButtonText: "Yes", // Text for the custom button
				buttonsStyling: false, // Disable SweetAlert2 styling for buttons
				customClass: {
					confirmButton:
						"btn btn-size akkurate-green-btn modal-btn-width text-white me-2", // Custom class for the "OK" button
					cancelButton:
						"btn btn-size akkurate-ash modal-btn-width text-white", // Custom class for the custom button
				},
			}).then(async (result) => {
				if (result.isConfirmed) {
					this.isDisbursing = false;
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
				} else if (result.isDismissed) {
					this.isLoading = true;
					this.isDisbursing = false;
					this.$Progress.start();
					this.$bvModal.hide(
						String(this.loan_no + this.statement)
					);
					await ApiService.post(`/journals/reverse/${index}`)
						.then((response) => {
							console.log(response);
							this.isLoading = false;
							this.$Progress.finish();
							toast.fire({
								icon: "success",
								title: response.data.message,
							});
							this.loadItems();
						})
						.catch((error) => {
							this.isDisbursing = false;
							this.isLoading = false;
							this.$Progress.fail();
							toast.fire({
								icon: "error",
								title: error.response.data.message,
							});
							// if (error.response.data.errors) {
							//     this.form.errors = error.response.data.errors;
							// }
						});
				}
			});
		},
		async exportToExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx"; // Path to the file in the public folder
			const imageUrl = "/default_logo.png"; // Path to your image file

			// Institution details
			const institutionName = this.institution.name;
			const institutionMotto = this.institution.motto;
			const institutionAddress = this.institution.address;
			const institutionPhone = this.institution.telephone;
			const institutionEmail = this.institution.email;

			try {
				// Fetch the Excel file from the public URL
				const response = await fetch(fileUrl);
				if (!response.ok) {
					throw new Error(
						`Network response was not ok: ${response.statusText}`
					);
				}
				const arrayBuffer = await response.arrayBuffer();

				// Load the file into ExcelJS
				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);

				// Access the first sheet
				const ws = wb.getWorksheet(1); // Get the first worksheet

				// Add Image to the top of the sheet
				const imageResponse = await fetch(imageUrl);
				const imageBuffer = await imageResponse.arrayBuffer();
				const imageId = wb.addImage({
					buffer: imageBuffer,
					extension: "png", // Adjust this if you're using a different image type (e.g., jpg)
				});

				// Insert the image at the top-left corner (row 1, column 1)
				ws.addImage(imageId, {
					tl: { col: 0, row: 0 }, // Top-left corner (adjust this as needed)
					ext: { width: 300, height: 200 }, // Set the image size (adjust width/height as needed)
				});

				// Insert institution details next to the image (starting at row 1, col 5)
				const institutionDetailsStartCol = 5; // Column where text starts after image
				const institutionDetailsRow = 1; // Row for institution details

				// Add the institution name, address, and phone number
				ws.getCell(`I${institutionDetailsRow}`).value = institutionName;
				ws.getCell(`I${institutionDetailsRow}`).font = { bold: true, size: 14 }; // Bold and bigger font for name

				ws.getCell(`I${institutionDetailsRow + 1}`).value = institutionAddress;
				ws.getCell(`I${institutionDetailsRow + 1}`).font = { size: 12 };  // Regular font size for address

				ws.getCell(`I${institutionDetailsRow + 2}`).value = institutionMotto;
				ws.getCell(`I${institutionDetailsRow + 2}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 3}`).value = institutionPhone;
				ws.getCell(`I${institutionDetailsRow + 3}`).font = { size: 12 };  // Regular font size for phone

				ws.getCell(`I${institutionDetailsRow + 4}`).value = institutionEmail;
				ws.getCell(`I${institutionDetailsRow + 4}`).font = { size: 12 };  // Regular font size for phone

				// Optionally adjust the column width if the text is long
				ws.getColumn('J').width = 50;  // Adjust the width of column D (if necessary)

				// Define header row
				const header = [
					"Recorded Date",
					"References",
					"Code",
					"Branch",
					"Amount",
					"Narration",
					"Status",
					"Created by",
				];



				// Add header row starting from row 13 (or the next row after the image and details)
				const startingRow = institutionDetailsRow + 10; // Row 4 after institution details
				let headerRow = ws.getRow(startingRow);
				headerRow.values = header;
				headerRow.font = { bold: true };
				headerRow.commit(); // Commit the row to the worksheet

				// Add individual data rows
				let currentRow = startingRow + 1;

				// Process each item
				this.rows.forEach(item => {
					const row = ws.getRow(currentRow);
					// Map item values to the corresponding header columns
					row.values = [
						item.recorded_date,
						`JOU${item.id}`,
						item.code,
						item.branch.name,
						item.amount_requested,
						item.narration,
						item.status,
						item.created_by?.first_name + " " + item.created_by?.surname,
					];
					row.commit();
					currentRow++;
				});
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

				// Create a download link and simulate a click to download the file
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = "journal_export.xlsx";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			} catch (err) {
				console.error(
					"Error fetching, modifying, or downloading the Excel file:",
					err.message
				);
			}
		},
		show_more() {
			this.more_details = !this.more_details;
		},
		async getInsistution() {
			await ApiService.get("/settings/institution")
				.then((response) => {
					// console.log(response);
					this.institution = response.data.data;
				})
				.catch((error) => {
					// console.log(error);
				});
		},
		checkPemission() {
			this.status_permission = hasPermission("journal_management_edit");
		},
	},
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
